import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { iModalConfirm } from '../interfaces/modal-confirm.interface';
import { ModalConfirmComponent } from '../components/modal-confirm/modal-confirm.component';

@Injectable({
  providedIn: 'root'
})
export class OpenModalConfirmService {
  private dialog = inject(MatDialog);
  private activeModalKeys = new Set<string>();

  isModalOpen(key: string): boolean {
    return this.activeModalKeys.has(key);
  }

  openModalConfirm(data: iModalConfirm): Observable<any> {
    if (data.key && this.activeModalKeys.has(data.key)) {
      return of(undefined);
    }

    if (data.key) {
      this.activeModalKeys.add(data.key);
    }

    const savedScrollY = (typeof window !== 'undefined') ? (window.scrollY || window.pageYOffset || 0) : 0;

    const ref = this.dialog.open(ModalConfirmComponent, {
      data,
      autoFocus: false,
      restoreFocus: false,
      disableClose: data.noCloseByOutsideClick === true
    });

    const afterClosed$ = ref.afterClosed();
    afterClosed$.subscribe(() => {
      if (data.key) {
        this.activeModalKeys.delete(data.key);
      }

      try {
        setTimeout(() => {
          if (typeof window !== 'undefined') {
            window.scrollTo(0, savedScrollY);
          }
        }, 0);
      } catch (e) {
        // ignore
      }
    });

    return afterClosed$;
  }
}
